<template>
    <v-dialog
        v-model="dialogNegociarProyecto"
        persistent
        max-width="600px"
    >
        <v-card>
            <v-card-text>
                <v-container>
                <template>
                    <v-form
                        ref="formNegociacion"
                        lazy-validation
                        @submit.prevent="save()"
                    >
                        <v-card-title class="pa-2">
                            Negociar Entidad Técnica
                            <v-spacer />
                        <v-spacer />
                        </v-card-title>
                        <v-row>
                            <v-col
                                lg="6"
                            >
                                <v-select
                                v-model="departamento"
                                outlined
                                flat
                                :items="regiones"
                                label="Selecciones departamento de despacho"
                                :rules="[v => !!v || 'El departamento de despacho es requerido']"
                                />
                                <!-- @change="onChangeRegion" -->
                            </v-col>
                            <!-- <v-col
                                lg="6"
                            >
                                <v-select
                                    v-model="provincia"
                                    class="px-2 py-1"
                                    outlined
                                    flat
                                    :items="provincias"
                                    label="Seleccione la provincia (Excepto region Lima, Seleccione distrito)"
                                    required
                                />
                            </v-col> -->
                        </v-row>

                        <v-select
                            v-model="estadoDeNegociacion"
                            :items="$store.state.estadosNegociacionEntidadTecnica"
                            :rules="[v => !!v || 'Estado de negociacion es obligatorio']"
                            label="Seleccione estado de negociacion"
                            data-vv-name="select"
                            :error-messages="isValidoComoNegociacionGanada"
                            outlined
                            required
                        />

                        <v-text-field
                            v-if="estadoDeNegociacion === 'GANADO' && !isValidoComoNegociacionGanada"
                            v-model="ganoEntidadTecnica"
                            label="Nro de pedido"
                            outlined
                            :rules="[v => !!v || 'Nro de pedido es obligatorio']"
                        />

                        <v-text-field
                            v-if="estadoDeNegociacion === 'PERDIDO' && !isValidoComoNegociacionGanada"
                            v-model="perdioEntidadTecnica"
                            label="Porqué se perdió?"
                            outlined
                            :rules="[v => !!v || 'Porqué se perdió es obligatorio']"
                        />

                        <v-slider
                            v-model="porcentajeDeCierre"
                            label="Posibilidad de cierre"
                            step="10"
                            color="orange darken-3"
                            thumb-label
                            ticks
                            :rules="[v => v>0 || 'Posibilidad de cierre debe ser mayor a 0']"
                        />

                        <!---Etapa de obra--->
                        <v-select
                            v-model="etapaDeConstruccion"
                            :items="$store.state.etapasDeContrucionDeNegociacionEntidadTecnica"
                            label="Seleccione la etapa de obra"
                            data-vv-name="select"
                            outlined
                            required
                            :rules="[v => !!v || 'Etapa de obra es obligatorio']"
                        />

                        <v-select
                            v-model="incluyePuertaPrincipal"
                            :items="$store.state.incluyePuertaPrincipal"
                            label="Incluye puerta principal"
                            data-vv-name="select"
                            outlined
                            required
                            :rules="[v => !!v || 'Seleccionar puerta principal es obligatorio']"
                        />

                        <!---Cantidad de Modulos--->
                        <v-text-field
                            v-model="cantidadDeModulosUpdated"
                            label="Cantidad de modulos*"
                            outlined
                            :rules="[v => !!v || 'Cantidad de modulos es obligatorio',v => v > 0 || 'La cantidad de modulos debe ser mayor a 0']"
                        />

                        <!---Monto Puertas--->
                        <v-text-field
                            v-model="MontoEnSoles"
                            label="Monto puertas y marcos*"
                            prefix="S/."
                            outlined
                            :rules="[v => !!v || 'Monto de puertas es obligatorio',v => v > 0 || 'Monto de puerta debe ser mayor a 0']"
                        />
                        <!---Fecha de facturación--->
                        <v-menu
                        ref="menuFechaFacturacion"
                        v-model="menuFechaDeFacturacion"
                        :close-on-content-click="false"
                        :return-value.sync="FechaDeFacturacion"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                            v-model="FechaDeFacturacion"
                            label="Fecha de facturación"
                            prepend-icon="mdi-calendar"
                            readonly
                            outlined
                            required
                            :rules="[v => !!v || 'Fecha de facturación es obligatorio']"
                            v-bind="attrs"
                            v-on="on"
                            >
                            </v-text-field>
                        </template>
                        <v-date-picker
                            v-model="FechaDeFacturacion"
                            type="month"
                            no-title
                            scrollable
                        >
                            <v-spacer />
                            <v-btn
                            text
                            color="primary"
                            @click="menuFechaFacturacion = false"
                            >
                            Cancel
                            </v-btn>
                            <v-btn
                            text
                            color="primary"
                            @click="$refs.menuFechaFacturacion.save(FechaDeFacturacion)"
                            >
                            OK
                            </v-btn>
                        </v-date-picker>
                        </v-menu>

                                <!---Botones de acción--->
                        <v-row>
                            <v-spacer />
                            <div class="mx-3" />
                            <v-btn
                                color="danger"
                                @click="close"
                            >
                                Cerrar
                            </v-btn>
                            <v-btn
                                class="mr-4"
                                color="primary"
                                type="submit"
                                :loading="isLoadingSubmit"
                            >
                                Crear
                            </v-btn>
                        </v-row>
                    </v-form>
                </template>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data () {
        return {
            isLoadingSubmit: false,
            departamento: undefined,
            regiones: [],
            provincia: '',
            provincias: [],
            estadoDeNegociacion: '',
            ganoEntidadTecnica: '',
            perdioEntidadTecnica: '',
            porcentajeDeCierre: '',
            etapaDeConstruccion: '',
            incluyePuertaPrincipal: '',
            MontoEnSoles: null,
            menuFechaDeFacturacion: false,
            FechaDeFacturacion: '',
            search: '',
            dialogNegociarProyecto: false,
            entidadTecnica: {},
            convocatoria: {},
            contactos: [],
            cantidadDeModulosUpdated: null,
        }
    },
    computed: {
        isValidoComoNegociacionGanada () {
            return ''

            /*if (this.estadoDeNegociacion === 'GANADO') {
                return (this.contactos.length > 0 && this.entidadTecnica.direccionReal !== undefined && this.entidadTecnica.departamentoReal && this.entidadTecnica.provinciaReal) ? '' : 'No puede selecionar la opción de negociación ganada hasta que haya ingresado los datos de contacto, dirección y ubicación real.'
            }
            if (this.estadoDeNegociacion === 'PERDIDO') {
                return ((this.contactos.length > 0 && this.entidadTecnica.direccionReal !== undefined && this.entidadTecnica.departamentoReal && this.entidadTecnica.provinciaReal)) ? '' : 'No puede selecionar la opción de negociación perdida hasta que haya ingresado los datos de contacto, dirección y ubicación real.'
            } else {
                return ''
            } */
        }
    },
    mounted () {
        this.getRegiones()
    },
    methods: {
        async open (entidadTecnica, convocatoria) {
            this.entidadTecnica = entidadTecnica
            this.cantidadDeModulosUpdated = entidadTecnica.cantidadDeModulo
            this.convocatoria = convocatoria
            await this.getNegociacion()
            await this.getContactosDeEntidadesTecnicas()

            this.dialogNegociarProyecto = true
        },
        close () {
            this.dialogNegociarProyecto = false
            this.isLoadingSubmit = false
            this.$refs.formNegociacion.reset()
        },
        getRegiones () {
            this.regiones = []
            this.$store.state.regiones.forEach(region => {
                this.regiones.push(region.NOMBRE)
            })
        },
        onChangeRegion () {
            var privinciaSeleccionadaByFiltro = this.$store.state.regiones.filter(region => region.NOMBRE === this.departamento)
            this.provincias = privinciaSeleccionadaByFiltro[0].PROVINCIAS
        },
        async save () {
            if (this.$refs.formNegociacion.validate()) {
                this.isLoadingSubmit = true
                const payload = {
                    departamento_de_despacho: this.departamento,
                    estado_de_negociacion: this.estadoDeNegociacion,
                    gano_entidad_tecnica: this.ganoEntidadTecnica || '',
                    perdio_entidad_tecnica: this.perdioEntidadTecnica || '',
                    porcentaje_de_cierre: parseInt(this.porcentajeDeCierre),
                    etapa_de_contratacion: this.etapaDeConstruccion,
                    incluye_puerta_principal: this.incluyePuertaPrincipal,
                    monto_en_soles: this.MontoEnSoles,
                    fecha_de_facturacion: this.FechaDeFacturacion,
                    entidad_tecnica: this.entidadTecnica.id,
                    convocatoria: this.convocatoria.id,
                    cantidad_de_modulos: parseInt(this.cantidadDeModulosUpdated)
                }

                const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/negociacion/' + this.convocatoria.id + '/' + this.entidadTecnica.id, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                })
                const data = await response.json()
                if (data.success) {
                    this.close()
                    this.$emit('onNegociar')
                } else {
                    this.close()
                    this.$emit('onNegociar')
                }
            } 
        },
        async getNegociacion () {
            const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/negociacion/' + this.convocatoria.id + '/' + this.entidadTecnica.id)
            const data = await response.json()
            if (data.success) {
                this.departamento = data.data[0].departamento_de_despacho
                this.estadoDeNegociacion = data.data[0].estado_de_negociacion
                this.ganoEntidadTecnica = data.data[0].gano_entidad_tecnica
                this.perdioEntidadTecnica = data.data[0].perdio_entidad_tecnica
                this.porcentajeDeCierre = data.data[0].porcentaje_de_cierre
                this.etapaDeConstruccion = data.data[0].etapa_de_contratacion
                this.incluyePuertaPrincipal = data.data[0].incluye_puerta_principal
                this.MontoEnSoles = data.data[0].monto_en_soles
                this.FechaDeFacturacion = data.data[0].fecha_de_facturacion
                this.cantidadDeModulosUpdated = data.data[0].cantidad_de_modulos
            }            
            if (this.departamento) {
                this.onChangeRegion()
            }
        },
        async getContactosDeEntidadesTecnicas () {
            this.contactos = []
            const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/contacto/' + this.entidadTecnica.id, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            })

            const data = await response.json()
            if (data.success) {
                this.contactos = data
            } else {
            }
        },
    }
}
</script>

<style>

</style>
